import Link from "next/link";
import type { ReactNode } from "react";
import { IconExternal } from "@/components/ui/icons";
import type { MenuLink } from "@/features/site-content/menus";

// Site Yönetimi → Menüler bağlantısı: site içi yol <Link>, mutlak adres <a rel="noopener noreferrer">. Yeni sekmede
// açılan bağlantıda küçük dış bağlantı ikonu ve ekran okuyucu için "(yeni sekmede açılır)". İngilizce sayfada Türkçe
// kalan yazı lang="tr", yalnızca Türkçe olan hedef hreflang="tr" alır. Hem sunucu (altbilgi) hem istemci (menüler) kullanır.

type Props = {
  link: MenuLink;
  newTabLabel: string;
  className?: string;
  onClick?: () => void;
  current?: boolean;
  /** Yazı yerine özel içerik (lang işaretini çağıran verir) */
  children?: ReactNode;
  /** İkon ve "yeni sekmede açılır" metninden sonra gelen içerik (açılır menüde açıklama satırı) */
  after?: ReactNode;
};

export function MenuLabel({ link }: { link: Pick<MenuLink, "label" | "lang"> }) {
  return link.lang ? <span lang={link.lang}>{link.label}</span> : <>{link.label}</>;
}

export function MenuAnchor({ link, newTabLabel, className, onClick, current, children, after }: Props) {
  const content = (
    <>
      {children ?? <MenuLabel link={link} />}
      {link.newTab && (
        <>
          <IconExternal size={13} className="ml-1 inline-block shrink-0 align-[-1px] opacity-70" />
          <span className="sr-only"> {newTabLabel}</span>
        </>
      )}
      {after}
    </>
  );
  const common = {
    href: link.href,
    className,
    onClick,
    hrefLang: link.hrefLang,
    "aria-current": current ? ("page" as const) : undefined,
    ...(link.newTab ? { target: "_blank" } : {}),
  };
  if (link.external) {
    return (
      <a {...common} rel="noopener noreferrer">
        {content}
      </a>
    );
  }
  return link.newTab ? (
    <a {...common} rel="noopener">
      {content}
    </a>
  ) : (
    <Link {...common}>{content}</Link>
  );
}
